<span>
  <app-multiselect-list-view
    [columnDefinition]="columnDefinition"
    [itemsSource]="file"
    [selectAll]="true"
    [menuDefinition]="menuDefinition"
    [preferencesKey]="preferencesKey"
    (rowClick)="onControlDataRowClicked($event)"
  >
  </app-multiselect-list-view>
</span>
